<template>
    <div class="mapa bordas">
        <b-alert variant="info" :show="tipoLeitoFiltradoStatus != null ? true : false" class="text-center">
            Filtrando por: <strong>{{tipoLeitoFiltradoStatus}}</strong>
        </b-alert>

        <p class="text-muted" v-if="listagemMapaTipoLeito.length < 1">Sem dados para a pesquisa realizada</p>

        <div v-for="(item, index) in listagem" :key="index">
            <div class="bordas mt-3" v-if="item.conteudo.length > 0">
                <div class="titulo-unidade-tpleito">{{item.unidade}} <span class="qtd-leitos">{{item.conteudo.length}}</span></div>
                <div class="mapa-leitos">
                    <leitos 
                        v-for="(leito, indexdentro) in item.conteudo"
                        :key="indexdentro" 
                        :dados="leito" 
                        :index="indexdentro"
                        :indexexterno="index"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Leitos from './leitos/Leitos.vue'

export default {
    components: {
        Leitos
    },
    computed: {
        listagemMapaTipoLeito () {
            return this.$store.getters['tipoleito/getMapaTipoLeito']
        },
        tipoLeitoFiltradoStatus () {
            return this.$store.getters['tipoleito/getTipoLeitoFiltradoStatus']
        },
        listagem () {
            if (this.tipoLeitoFiltradoStatus == null){
                this.quantitativoLeitos(this.listagemMapaTipoLeito)
                return this.listagemMapaTipoLeito
            } 
            else {
                let resultado = []

                this.listagemMapaTipoLeito.forEach((i, index) => {
                    let dado = i.conteudo.filter(f => f.nomeTipoClinico == this.tipoLeitoFiltradoStatus)
                    resultado.push({unidade: i.unidade, conteudo: dado})
                })
                this.quantitativoLeitos(resultado)

                return resultado
            }
        }
    },
    methods: {
        quantitativoLeitos (array) {
            let livres = []
            let cedidos = []

            array.forEach((i, index) => {
                i.conteudo.forEach((item) => {
                    if (item.leitoStatus == '0') livres.push(item.leitoStatus)
                    if (item.leitoStatus == '4' || item.leitoStatus == '5') cedidos.push(item.leitoStatus)
                })
            })

            this.$store.commit('tipoleito/setQuantitativoLeitos', {livres: livres.length, cedidos: cedidos.length})
        }
    }
}
</script>

<style>
.mapa {
    background-color: #ffffff;
    flex-grow: 1;
    order: 3;
    padding: 20px 0;
    margin: 0;
    overflow-y: scroll;
}

.mapa-leitos {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

@media (min-width: 1154px) {
    .mapa {
        order: 2;
        margin: 0 20px;
    }

    .mapa-leitos {
        justify-content: flex-start;
    }
}

.display-leito {
    height: 86px;
    width: 64px;
    border-radius: 5px;
    margin: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}

.cod_leito {
    font-weight: 700;
    font-size: 14px;
    display: block;
    text-align: center;
}

.cod_enfermaria {
    font-weight: 400;
    font-size: 14px;
    margin-right: 2px;
}

.icone_leito {
    width: 46px;
}

.titulo-unidade-tpleito {
    padding: 3px 10px;
    background-color: #006e95;
    color: #fff;
    border-radius: 3px;
    font-size: .9rem;
    font-weight: 600;
    width: 100%;
    text-align: center;
}

.qtd-leitos {
    padding: 0 5px;
    background-color: #4fac68;
    border-radius: 4px;
    margin-left: 10px;
    float: right;
}
</style>
